module.exports = __webpack_public_path__ + "static/SVHome-04-34ffaa796f2d925862e51b2261aa0d04.png";